import styled from 'styled-components';
import { ComboboxMixin } from '../../mixins/components/ComboboxMixin';
export var StyledCombobox = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCombobox",
  componentId: "c11n-8-111-1__sc-1tu6hwf-0"
})(["", ""], ComboboxMixin);